<script lang="ts">
import { inject } from 'vue'
import type Map from 'ol/Map.js'
import SearchGeoportail from 'ol-ext/control/SearchGeoportail'
import Placemark from 'ol-ext/overlay/Placemark'
import { fromLonLat } from 'ol/proj'

export default {
    name: 'DkOlGeosearch',
    components: {},
    props: {
        xmin: { type: Number, required: false },
        ymin: { type: Number, required: false },
        xmax: { type: Number, required: false },
        ymax: { type: Number, required: false },
    },
    data() {
        return {
            search: null,
            map: inject('map') as Map,
        }
    },
    mounted() {
        const placemark = new Placemark ({
            contentColor: '#000',
            onshow: () => {
                // once it’s shown, attach a click listener to its element
                const el = placemark?.getElement()
                if (el) {
                    el.style.cursor = 'pointer'
                    el.addEventListener('click', () => placemark?.hide(), { once: true })
                }
            },
            autoPan: {
                animation: {
                    duration: 250,
                },
            },
        })
        this.map.addOverlay(placemark)

        this.search = new SearchGeoportail({
            // apiKey: apiKey,
            type: 'StreetAddress',
            // version: 2,
            reverse: true,
            terr: 'METROPOLE',
            label: 'Rechercher une adresse',
            placeholder: 'Rechercher une adresse',
            reverseTitle: 'Cliquer sur la carte pour avoir l\'adresse (ou les coordonnées si aucune adresse ne correspond)',
        })
        this.search.set('position', true)

        const bbox = this.getBboxInProjection()
        if (bbox?.length)
            this.search.set('bbox', bbox)

        this.search.search() // To pass new props to search component

        this.search.on('select', (e) => {
            placemark.show(e.coordinate)
            this.map.getView().animate({
                center: e.coordinate,
                zoom: Math.max (this.map.getView().getZoom(), 17),
            })
        })

        this.map.addControl(this.search)
    },
    unmounted(): void {
        this.map.removeControl(this.search)
        delete this.geoloc
    },
    methods: {
        getBboxInProjection(): Array<number> {
            // ["bbox: must be in the format \"xmin,ymin,xmax,ymax\""]}
            if (this.xmin && this.xmax && this.ymin && this.ymax) {
                return [...fromLonLat([this.xmin, this.ymin]), ...fromLonLat([this.xmax, this.ymax])]
            }
            return []
        },
    },
    render() {
        return null
    },
}
</script>

<style>
.ol-search input.search {
    background: white;
    border: 1px solid grey;
    padding: 5px;
    font-size: 16px;
}

.ol-search input.search {
    outline: none;
}

.ol-search ul {
    color: #333;
    font-size: 0.85em;
    max-width: 21em;
}
.ol-search ul i {
    display: block;
    color: #333;
    font-size: 0.85em;
}
.info a img {
    display: inline-block;
    height: 100px;
    max-width: 150px;
    margin: 0.5em;
}
.ol-search.ol-revers button.ol-revers {
    background-color: #ffcc33;
}
</style>
